import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-602a646b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container about-adjust-c" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "iframe-container" }, [
  /*#__PURE__*/_createElementVNode("iframe", {
    width: "608",
    height: "360",
    src: "https://www.youtube.com/embed/S6v1QZ675AI",
    title: "YouTube video player",
    frameborder: "0",
    allow: "accelerometer; autoplay; clipboard-write; encrypted-media;\n                 gyroscope; picture-in-picture; web-share",
    allowfullscreen: ""
  })
], -1))
const _hoisted_3 = { class: "what-is-gio" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "what-is-gio-text" }, "What is G.IO?", -1))
const _hoisted_5 = {
  key: 0,
  class: "p-text"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, " browse active influencer marketing campaigns, take part, and get paid.", -1))
const _hoisted_7 = {
  key: 1,
  class: "p-text"
}
const _hoisted_8 = {
  key: 2,
  class: "p-text"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "influencer marketing campaigns.", -1))
const _hoisted_10 = {
  key: 3,
  class: "p-text p-mt-2"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, " thousands of ambitious micro and macro gaming influencers", -1))
const _hoisted_12 = { class: "p-d-flex p-mt-6 mobile" }
const _hoisted_13 = {
  key: 0,
  class: "material-icons arrow-circle"
}
const _hoisted_14 = {
  key: 1,
  class: "material-icons arrow-circle"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "demo-button" }, "Watch our demo", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["p-d-flex p-jc-center", _ctx.view === 'brand' ? 'about-adjust' : ''])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        (_ctx.view === 'creator')
          ? (_openBlock(), _createElementBlock("p", _hoisted_5, [
              _createTextVNode(" G.IO is a platform that allows content creators to"),
              _hoisted_6
            ]))
          : _createCommentVNode("", true),
        (_ctx.view === 'creator')
          ? (_openBlock(), _createElementBlock("p", _hoisted_7, " Connect with ambitious game developers and promote their games through your community. "))
          : _createCommentVNode("", true),
        (_ctx.view === 'brand')
          ? (_openBlock(), _createElementBlock("p", _hoisted_8, [
              _createTextVNode(" G.IO is a platform that allows game developers to run their own "),
              _hoisted_9
            ]))
          : _createCommentVNode("", true),
        (_ctx.view === 'brand')
          ? (_openBlock(), _createElementBlock("p", _hoisted_10, [
              _createTextVNode(" Connect with"),
              _hoisted_11,
              _createTextVNode(" and promote your games through their communities! ")
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_12, [
          (!_ctx.isMobile)
            ? (_openBlock(), _createElementBlock("span", _hoisted_13, "arrow_circle_left"))
            : (_openBlock(), _createElementBlock("span", _hoisted_14, "arrow_circle_down")),
          _hoisted_15
        ])
      ])
    ])
  ], 2))
}